export const pluralize = (
  text: string,
  compare: number | Array<any>,
  includeNumberPrefix: boolean = true,
  pluralExt: string = "s"
): string => {
  compare instanceof Array && (compare = compare.length);
  return (
    (includeNumberPrefix ? `${compare} ` : "") +
    (compare === 1 ? text : `${text}${pluralExt}`)
  );
};
